/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { Point, Rectangle } from 'pixi.js-legacy';

/**
 * Used when focusing on tickets, to specify which side of the ticket will the camera be aligned to.
 */
export enum CameraTicketAlignment {
	LEFT = 'left',
	RIGHT = 'right',
	CENTER = 'center',
}

/**
 * Options for focusing on tickets in the camera view.
 * @param z The zoom of the camera.
 * @param @see CameraTicketAlignment The alignment of the camera to the ticket.
 */
export interface FocusOnTicketsOptions {
	z?: number;
	align?: CameraTicketAlignment;
}

export interface ViewportChangedEvent {
	view: Rectangle;
	scale: Point;
	lastView?: Rectangle;
	lastScale?: Point;
}
